import type { KeyboardEvent } from 'react';

import { cn } from '~/lib/utils';

interface VacancyFilterComboboxOptionProps {
  option: string;
  isSelected: boolean;
  inputRef: (node: HTMLInputElement | null) => void;
  onToggle: () => void;
  onKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void;
}

export const VacancyFilterComboboxOption = ({
  option,
  isSelected,
  inputRef,
  onToggle,
  onKeyDown,
}: VacancyFilterComboboxOptionProps) => {
  return (
    <div
      role="option"
      aria-selected={isSelected}
      className="group transition-colors hover:bg-black/20 focus-within:bg-black/20"
    >
      <label className="flex h-10 cursor-pointer items-center gap-2 overflow-hidden px-3 py-2">
        <input
          ref={inputRef}
          type="checkbox"
          checked={isSelected}
          aria-label={option}
          onChange={onToggle}
          onKeyDown={onKeyDown}
          className="sr-only"
        />
        <span
          aria-hidden="true"
          className="flex size-5 shrink-0 items-center justify-center"
        >
          <span
            className={cn(
              'flex size-4 items-center justify-center rounded-[2px] border transition-colors',
              isSelected
                ? 'border-blue-primary bg-blue-primary'
                : 'border-graphite-400 bg-graphite-dark group-hover:border-blue-primary group-focus-within:border-blue-primary'
            )}
          >
            {isSelected ? (
              <svg
                viewBox="0 0 12 12"
                aria-hidden="true"
                className="size-3 text-white"
              >
                <path
                  d="M10 3 4.75 8.25 2 5.5"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.8"
                />
              </svg>
            ) : null}
          </span>
        </span>
        <span className="min-w-0 flex-1 truncate font-manrope text-[16px] leading-6 tracking-[0.16px] text-white">
          {option}
        </span>
      </label>
    </div>
  );
};
